//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getRandomElements } from "~/helpers/array";
import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowActivitiesList",

    props: {
        ...defaultBlockProps,
    },

    data: () => ({
        list: [],
    }),

    async fetch() {
        const list = [];

        try {
            const apiResult = await this.$axios.$get("/posts", {
                params: {
                    postType: "attivita",
                    culture: this.$store.app.i18n.locale,
                },
            });

            if (apiResult.isSuccess === false) {
                return;
            }

            if (apiResult.payload.posts.length === 0) {
                return;
            }

            const posts = [...apiResult.payload.posts].filter((el, idx) => {
                return el.post_status === "publish";
            });

            posts.forEach((item) => {
                let title = null;
                let text = null;
                let image = null;

                if (item.customFields && item.customFields.length > 0) {
                    const titleCf = item.customFields.filter(
                        (el) => el.cf_meta_key === "_titolo"
                    );
                    if (titleCf && titleCf[0] && titleCf[0].cfv_meta_value) {
                        title = titleCf[0].cfv_meta_value;
                    }

                    const textCf = item.customFields.filter(
                        (el) => el.cf_meta_key === "_testo"
                    );
                    if (textCf && textCf[0] && textCf[0].cfv_meta_value) {
                        text = textCf[0].cfv_meta_value;
                    }
                }

                if (
                    item.featuredImage !== null &&
                    typeof item.featuredImage !== "undefined"
                ) {
                    image = {
                        alt: item.featuredImage.post_title,
                        id: item.id,
                        image: {
                            height: 1080,
                            provider: "wordpress",
                            url: item.featuredImage.guid,
                            width: 1920,
                        },
                        type: "image",
                    };
                }

                if (title && text) {
                    list.push({
                        id: item.id,
                        title,
                        image,
                        text,
                    });
                }
            });

            if (list.length > 0) {
                this.list = getRandomElements(list, 2);
            }
        } catch (e) {
            console.error(e);
        }
    },
};
